export default {
  name: `loading_screen`,
  loadingText: `加载中`,
}